var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"sidebar-desktop"}},[_c('div',{staticClass:"filter-title"},[_vm._v("FILTERS")]),_c('Filters')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }